// extracted by mini-css-extract-plugin
module.exports = {"aplixSelectInputRoot":"aplixSelectInputRoot--84e37"};